import { apiInstance } from "../utils";

export const saveChatInterest = async () => {
  const response = await apiInstance.post("chat-interest");

  return response.data;
};
